import { render } from "./SpecificationTextarea.vue?vue&type=template&id=86ec89fe"
import script from "./SpecificationTextarea.vue?vue&type=script&lang=js"
export * from "./SpecificationTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__